@if (isCategoryDataLoading) {
  <app-loading-spinner></app-loading-spinner>
} @else {
  <!-- Header Section -->
  <div class="d-flex flex-wrap justify-content-between align-items-center mb-3">
    <div>
      <h5 class="mb-1 fw-bold">Raw Material Categories</h5>
      <span class="sub-text">Organize your raw materials by category</span>
    </div>

    <button class="btn btn-primary btn-enjochem" (click)="openAddCategoryModal()">
      <i class="bi bi-plus-circle"></i>
      <span>Add Category</span>
    </button>
  </div>

  <div class="input-group mb-4">
    <span class="input-group-text bg-white border-end-0">
      <i class="bi bi-search text-muted"></i>
    </span>
    <input
      type="text"
      class="form-control border-start-0 ps-0"
      placeholder="Search by name or short code"
      aria-label="Search categories"
      [(ngModel)]="searchTerm" />
  </div>

  <div class="table-responsive border bg-white">
    @if (filteredCategories.length === 0) {
      <div class="empty-state-container">
        <i class="bi bi-folder"></i>
        @if (categories.length > 0) {
          <h5>No Matching Categories</h5>
          <p>
            Nothing matches "{{ searchTerm }}".
            <button class="btn btn-link p-0 align-baseline" (click)="clearSearch()">Clear the search</button>
            to see all {{ categories.length }}.
          </p>
        } @else {
          <h5>No Categories Found</h5>
          <p>
            You can add a category by clicking the
            <strong>+ Add Category</strong>
            button.
          </p>
        }
      </div>
    } @else {
      <ul class="list-group list-group-flush">
        <li
          class="list-group-item d-flex justify-content-between align-items-center py-3"
          *ngFor="let category of filteredCategories">
          <div class="d-flex align-items-center gap-2">
            <span class="badge bg-secondary-subtle text-secondary font-monospace">{{ category.short_code }}</span>
            <span class="fw-semibold">{{ category.name | titlecase }}</span>
          </div>
          <div class="d-flex gap-2">
            <button class="btn btn-action-edit" (click)="editCategory(category)" title="Edit">
              <i class="bi bi-pencil"></i>
            </button>
            <button class="btn btn-action-delete" (click)="confirmDeleteCategory(category)" title="Delete">
              <i class="bi bi-trash"></i>
            </button>
          </div>
        </li>
      </ul>
    }
  </div>
}

<!-- Modal -->
<div class="modal fade show" tabindex="-1" style="display: block; background: rgba(0, 0, 0, 0.5)" *ngIf="showModal">
  <div class="modal-dialog">
    <div class="modal-content">
      <form (ngSubmit)="saveCategory()" [formGroup]="categoryForm">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ selectedCategory?.id ? 'Edit Category' : 'Add Category' }}
          </h5>
          <button type="button" class="btn-close" (click)="closeModal()"></button>
        </div>

        <div class="modal-body">
          <div class="row g-3">
            <div class="col-8">
              <label for="categoryName" class="form-label">Category Name</label>
              <input
                type="text"
                id="categoryName"
                class="form-control"
                formControlName="name"
                [class.is-invalid]="categoryForm.get('name')?.invalid && categoryForm.get('name')?.touched" />
              <div class="invalid-feedback">Category name is required.</div>
            </div>
            <div class="col-4">
              <label for="categoryShortCode" class="form-label">Short Code</label>
              <input
                type="text"
                id="categoryShortCode"
                class="form-control font-monospace text-uppercase"
                formControlName="short_code"
                maxlength="10"
                placeholder="e.g. BOT"
                [class.is-invalid]="
                  categoryForm.get('short_code')?.invalid && categoryForm.get('short_code')?.touched
                " />
              <div class="invalid-feedback">Short code is required.</div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
          <button type="submit" class="btn btn-primary" [disabled]="categoryForm.invalid">
            {{ selectedCategory?.id ? 'Update' : 'Create' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
